/*
 * @Author: Hyman Choi
 * @Date: 2021-01-14 10:38:22
 * @LastEditTime: 2022-01-14 16:50:38
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Siui.Cloud.Medical.Web\src\router\Modules\cloudService.js
 */
import Layout from '@/layout'

const cloudServiceRouter = {
  path: '/cloudService',
  component: Layout,
  redirect: '/cloudService/messageList',
  name: 'cloudService',
  meta: {
    roles: ['超级管理员'],
    title: 'cloudService',
    icon: 'cloudService'
  },
  children: [
    {
      path: 'messageList',
      name: 'messageList',
      component: () => import('@/views/cloudService/messageList/index'),
      meta: {
        roles: ['超级管理员'],
        title: 'messageList'
      }
    },
    {
      path: 'staffList',
      name: 'staffList',
      component: () => import('@/views/cloudService/staffList/index'),
      meta: {
        roles: ['超级管理员'],
        title: 'staffList'
      }
    }
  ]
}

export default cloudServiceRouter
